import type { SerializedFeatureReferenceBinding } from './FeatureReferenceBinding';
import { ModelTopologyFeatureBinding } from './ModelTopologyFeatureBinding';
import { SketchProfileFeatureBinding } from './SketchProfileFeatureBinding';
import { SketchSubEntityFeatureBinding } from './SketchSubEntityFeatureBinding';
import { ExtrudeReferenceFeatureBinding } from './ExtrudeReferenceFeatureBinding';

/**
 * 从序列化载荷恢复特征引用绑定对象。
 *
 * @param payload 序列化绑定载荷。
 * @returns 绑定对象实例。
 * @throws 当载荷中的绑定类型不是 SDK 支持的特征引用类型时。
 */
export function createFeatureReferenceBinding(payload: SerializedFeatureReferenceBinding) {
    if (payload.kind === 'extrude-reference') return new ExtrudeReferenceFeatureBinding(payload);
    if (payload.kind === 'sketch-profile') {
        return new SketchProfileFeatureBinding(payload);
    }
    if (payload.kind === 'sketch-sub-entity') {
        return new SketchSubEntityFeatureBinding(payload);
    }
    if (payload.kind === 'model-topology') {
        return new ModelTopologyFeatureBinding(payload);
    }
    throw new Error(`不支持的特征引用绑定类型: ${(payload as { kind?: unknown }).kind ?? 'unknown'}`);
}
